import { toast } from 'react-toastify';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import api from 'client';
import useAuth from './useAuth';

export default () => {
  const { id } = useAuth();
  const { t } = useTranslation('labels');
  const updateTermsConsent = async (termsConsented) => {
    const data = { termsConsented };
    return api.put(`/apis/v2/accounts/${id}/terms_consent`, data);
  };

  const mutation = useMutation(updateTermsConsent, {
    onSuccess: () => {
      toast(t('success'));
      window.location.href = '/portal/appointments';
    },
    onError: (error) => {
      if (error.response?.data?.message) {
        toast.error(error.response?.data?.message);
      } else if (error.message) {
        toast.error(error.message);
      }
    },
  });

  return {
    updateTermsConsent: mutation.mutate,
  };
};
